import Image from 'next/image';
import Text from '@components/atoms/Text';
import { LoaderProps } from './Loader.types';
import styles from './Loader.module.scss';
import assetLoader from '@utils/internalImageLoder';

const Loader: React.FC<LoaderProps> = ({
  theme = 'light',
  text = 'Loading...',
  subText,
  variant = 'center',
  className,
  customStyle,
  size = 'medium'
}) => {

  const getSizeStyles = () => {
    const sizeMap = {
      small: { width: '60px', height: '60px' },
      medium: { width: '80px', height: '80px' },
      large: { width: '120px', height: '120px' }
    };
    return sizeMap[size];
  };

  const containerClasses = [
    styles.container,
    styles[`${variant}Container`],
    styles[size],
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={containerClasses} style={customStyle}>
      <Image
        src={`${assetLoader()}/Loader/Car-Loader-${theme == 'dark' ? 'Dark' : 'Light'}.gif`}
        alt="Loading..."
        width={parseInt(getSizeStyles().width)}
        height={parseInt(getSizeStyles().height)}
        className={styles.loaderGif}
        unoptimized 
        priority
      />
      <Text className={styles.loadingText}>{text}</Text>
      {subText && (
        <Text className={styles.loadingSubText}>{subText}</Text>
      )}
    </div>
  );
};

export default Loader; 